export default __webpack_public_path__ + "static/media/wheelStart.d4de878b.mp3";